import { Dialog, type LaboratoriesDataRefApi } from "@pharmupp/p3-front-commons"
import { useState } from "react"
import { AlertCircle } from "react-feather"
import type { FormattedNews } from "../../../commons/NewsComponents/News"

export const ConfirmPublishNewsDialog = ({
  news,
  onClickClose,
  validateAction,
}: {
  news: FormattedNews & { lab?: LaboratoriesDataRefApi }
  onClickClose: () => void
  validateAction: () => Promise<unknown>
}) => {
  const [enableAction, setEnableAction] = useState(true)
  return (
    <Dialog
      open={true}
      Icon={AlertCircle}
      title={`Publication de l’actu ${news.title} du laboratoire ${news.lab?.name}`}
      validateAction={async () => {
        try {
          setEnableAction(false)
          await validateAction()
          onClickClose()
        } catch (e) {
        } finally {
          setEnableAction(true)
        }
      }}
      validateEnabled={enableAction}
      cancelAction={() => {
        onClickClose()
      }}
      onClose={onClickClose}
    >
      Vous confirmez la publication de l’actualité telle que vous la visualisez?
    </Dialog>
  )
}
